export const getGrafanaEmbedURL = (id: string, authToken?: string): string => {
  const { GRAFANA_API_URL, GRAFANA_DASHBOARD_ID, GRAFANA_DASHBOARD_NAME } =
    JSON.parse(sessionStorage.getItem('api_url')!);

  const configParams = {
    auth_token: authToken || '',
    orgId: '1',
    panelId: id,
    theme: 'light',
  };

  const grafanaParams = new URLSearchParams(configParams);

  return `${GRAFANA_API_URL}/d-solo/${GRAFANA_DASHBOARD_ID}/${GRAFANA_DASHBOARD_NAME}?${grafanaParams.toString()}`;
};
